/* eslint-disable @typescript-eslint/no-explicit-any */
import { TriggerActionCategory } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import Triggers from "../../Triggers/Triggers";
export const RunbookTriggers: React.FC = (props: any) => {
    return <Triggers triggerActionCategory={TriggerActionCategory.Runbook} {...props}/>;
};
RunbookTriggers.displayName = "RunbookTriggers"
